import Joi from 'joi';

import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { ReportTypeEnum } from '../../enums/report-type.enum';

/**
 * Schema for new report record validation.
 */
export const createReportSchema = () =>
	Joi.object({
		// Name
		name: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|report-name|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|report-name|required',
				'string.base': 'validations|report-name|must-be-string',
				'string.empty': 'validations|report-name|must-not-be-empty',
			}),
		}),

		// Type
		type: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|report-type|cannot-be-null',
			}),
			otherwise: Joi.string()
				.valid(...Object.values(ReportTypeEnum))
				.required()
				.messages({
					'any.required': 'validations|report-type|required',
					'any.only': 'validations|report-type|invalid-value',
				}),
		}),

		// Tags
		tags: createTagsSchema().messages({
			'array.base': 'validations|report-tags|invalid-value',
		}),
	})
		// Ignore extra fields
		.unknown();
